import Vue from "vue";
import Router from "vue-router";

import { app } from "./lib/firebase";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: {
        name: "login"
      }
    },
    {
      path: "/app",
      component: () => import("./layouts/MainLayout.vue"),
      children: [
        {
          path: "",
          redirect: {
            name: "home"
          }
        },
        {
          path: "",
          component: () => import("./layouts/MainLayout.vue"),
          children: [
            {
              path: "",
              component: () => import("./layouts/AppLayout.vue"),
              children: [
                {
                  path: "home",
                  name: "home",
                  component: () => import("./views/Home/Home.vue")
                }
              ]
            },
            {
              path: "welcome",
              component: () => import("./layouts/EmptyLayout.vue"),
              children: [
                {
                  path: "",
                  component: () => import("./views/Welcome/Welcome.vue"),
                  name: "welcome"
                }
              ]
            }
          ],
          meta: {
            isAuth: true
          }
        },
        {
          path: "auth",
          component: () => import("./layouts/EmptyLayout.vue"),
          children: [
            {
              path: "",
              component: () => import("./views/Auth/Auth.vue"),
              name: "login"
            }
          ]
        }
      ]
    },
    {
      path: "/call",
      component: () => import("./layouts/EmptyLayout.vue"),
      children: [
        {
          path: "",
          component: () => import("./views/Call/Call.vue")
        }
      ],
      beforeEnter: (to, from, next) => {
        if (!to.query.clientId) {
          next("/");
        } else {
          next();
        }
      }
    },
    {
      path: "*",
      component: () => import("./views/NotFound/NotFound.vue")
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta.isAuth)) {
    if (app.auth().currentUser) {
      next();
    } else {
      next({
        name: "login",
        query: {
          to: to.query.to || to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

export default router;
